export default __webpack_public_path__ + "static/media/7.97c3d491.svg";